import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'חוויה קולינרית יוצאת דופן. כל מנה היא יצירת אמנות, והשירות מוקפד עד הפרט האחרון. מסעדה ברמה בינלאומית.',
  author: 'מבקר המסעדות, הארץ'
}, {
  quote: 'לוּנה מצליחה לשלב בין אלגנטיות אירופאית לחום ישראלי. תפריט היין מרשים לא פחות מהאוכל עצמו.',
  author: 'מגזין השולחן'
}, {
  quote: 'ערב בלתי נשכח. הטעמים, האווירה, התאורה - הכל מתחבר לכדי סימפוניה מושלמת של חושים.',
  author: 'מדריך גומיו'
}];
export function Testimonials() {
  return <section className="py-32 bg-espresso relative" dir="rtl" data-id="element-160">
      {/* Subtle background texture */}
      <div className="absolute inset-0 opacity-5 bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.8)_0%,transparent_100%)] bg-[length:20px_20px]" data-id="element-161" />

      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-162">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8" data-id="element-163">
          {testimonials.map((item, idx) => <motion.div key={idx} className="flex flex-col items-center text-center px-4" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 1,
          delay: idx * 0.2
        }} data-id="element-164">
              <div className="flex gap-1 mb-8 text-gold" data-id="element-165">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" className="opacity-80" data-id="element-166" />)}
              </div>

              <p className="font-serif text-xl md:text-2xl text-cream/90 italic leading-relaxed mb-8" data-id="element-167">
                "{item.quote}"
              </p>

              <div className="w-8 h-[1px] bg-gold/50 mb-4" data-id="element-168" />
              <span className="font-sans text-sm text-gold uppercase tracking-widest" data-id="element-169">
                {item.author}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}